// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-campaign-titles {
  font-family: Roboto;
  color: #8e9190;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  gap: 10;
  line-height: 24px;
}
.cart-details-card {
  height: 700px;
  overflow-y: auto;
}

.card-campaign-text {
  color: #0a0f0d;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.card-campaign-price-text {
  color: #0a0f0d;
  font-family: Roboto;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.divider-editor-col {
  display: flex !important;
  justify-content: end !important;
  padding-top: 45px !important;
}
.check-box-campaigns {
  /* padding-inline: 30px !important;
  padding-top: 29px !important; */
  margin-bottom: 20px !important;
}
.edit-campaign-space-div {
  padding-left: 35px !important;
  padding-top: 60px !important;
}
.edit-campaign-text {
  font-size: 16px !important;
  font-weight: 600 !important;
}
.campaign-actions {
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
}
.card-campaign-total {
  color: #5b5e5d;
  font-family: Roboto;
  font-size: 19px;
  font-style: normal;
  font-weight: 400;
  line-height: 28.5px;
}
.proceed-to-checkout {
  color: #fff;
  font-family: Roboto;
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  display: inline-flex;
  padding: 12px 60px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #d2042d;
  margin-top: 10px;
  height: 40px !important;
  width: 100% !important;
}
.proceed-to-checkout.ant-btn-variant-solid:disabled {
  background-color: #d2042d !important;
  color: #fff !important;
}
.proceed-to-checkout:hover {
  color: #fff;
  background-color: #910621 !important;
}
.checkout-card {
  width: 100%;
  height: auto;
  flex-shrink: 0;
}
.checkout-card.ant-card .ant-card-body {
  padding: 42px !important;
}
.cart-details-section {
  padding-inline: 75px;
}
.number-of-campaigns-collected {
  font-family: Roboto;
  font-weight: 600;
  font-size: 19px;
  line-height: 28.5px;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
}
.card-campaign-total-number {
  font-family: Roboto;
  font-weight: 700;
  font-size: 23px;
  line-height: 28.5px;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #000);
}
.card-campaign-actions-col {
  display: flex;
  justify-content: end;
  padding-top: 45px;
  margin-bottom: 10px;
  align-items: center;
  gap: 15px !important;
}

.card-campaign-actions-div {
  padding-left: 35px;
  padding-top: 60px;
}

.card-campaign-actions-div-text {
  font-size: 16px;
  font-weight: 600;
}
.badge {
  position: absolute;
  top: 0px;
  right: 0px;
  opacity: 1;
  border-bottom-left-radius: 10px;
  padding: 8px;
  gap: 8px;
  /* background: #ffd9e1; */
  padding: 4px 8px;
}
.expired-ribbon-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
.check-box-campaigns {
  /* padding-inline: 30px !important;
  padding-top: 29px !important; */
  margin-bottom: 20px !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 16px;
}
.check-box-campaigns.ant-card .ant-card-body {
  padding: 0px !important;
}
.check-out-version-bottom-card {
  display: flex;
  justify-content: center;
  align-items: center;
}
.checkout-total-button-row {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.number-of-products-cart-campaign-col {
  display: flex;
  flex-direction: column;
}
.number-of-products-cart-campaign-row {
  gap: 10px !important;
}
.cart-campaign-warning-icon-version {
  width: 20px !important;
}
.subtotal-label {
  color: #5b5e5d;
  font-weight: bold;
}
.cart-campaign-warning-icon {
  cursor: pointer;
}
.campaign-actions-icons {
  margin-right: 7px !important;
}
.remove-terms-in-cart {
  font-family: Roboto;
  font-weight: 400;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  color: var(--Colors-Primary-500, #0a0f0d);
}
.highleted-remove-terms {
  cursor: pointer;
  font-family: Roboto;
  font-weight: 400;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
.highleted-remove-terms:hover {
  text-decoration: none !important;
}
.any-terms-applied-remove-link {
  justify-content: center;
  margin-top: 1rem !important;
}
.alert-note-text {
  font-family: Roboto;
  font-weight: bold;
  font-size: 19px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  color: var(--Colors-Primary-500, #0a0f0d);
}
.campaign-actions-container {
  display: flex;
  align-items: center !important;
}
.re-designed-cart-brand-awareness {
  width: 45%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 5%;
}
.remove-campaign-text {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Regular;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.37px;
  color: #d2042d;
  cursor: pointer;
}
.cart-remove-from-cart {
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  gap: 5px;
}
@media (min-width: 1024px) and (max-width: 1440px) {
  .cart-details-section {
    padding-inline: 50px !important;
  }
  .card-campaign-titles {
    font-size: 14px !important;
  }
  .card-campaign-price-text {
    font-size: 17px !important;
  }
  .proceed-to-checkout {
    width: 100% !important;
  }
  .campaign-actions {
    font-size: 15px !important;
  }
  .card-campaign-text {
    font-size: 15px !important;
  }
  .campaign-actions-icons {
    width: 17px !important;
    height: 17px !important;
    margin-right: 2px !important;
  }
  .card-campaign-total {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
  .card-campaign-total {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
  .number-of-campaigns-collected {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
  .card-campaign-total-number {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
  .proceed-to-checkout {
    font-size: 16px !important;
  }
  .alert-note-text {
    font-size: 16px !important;
  }
  .remove-terms-in-cart {
    font-size: 16px !important;
  }
  .highleted-remove-terms {
    font-size: 16px !important;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .card-campaign-price-text {
    font-size: 20px !important;
  }
  .check-box-cart-col {
    margin-bottom: 3rem !important;
  }
  .checkout-card {
    width: 100%;
    height: auto;
    flex-shrink: 0;
    position: sticky;
  }
  .proceed-to-checkout {
    width: 100% !important;
  }
  .meidum-screen-action-buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 20px;
  }
  .check-box-campaigns {
    padding-bottom: 20px !important;
  }
  .cart-details-card {
    height: 634px !important;
  }
  .checkout-card {
    height: auto !important;
  }
  .card-campaign-total {
    font-size: 17px !important;
    line-height: 24.5px !important;
  }
  .cart-details-section {
    padding-inline: 25px !important;
  }
  .proceed-to-checkout {
    font-size: 16px !important;
  }
  .alert-note-text {
    font-size: 16px !important;
  }
  .remove-terms-in-cart {
    font-size: 16px !important;
  }
  .highleted-remove-terms {
    font-size: 16px !important;
  }
  .number-of-campaigns-collected {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
  .card-campaign-total-number {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
}
@media (min-width: 770px) and (max-width: 820px) {
  .proceed-to-checkout {
    font-size: 14px !important;
  }
}
@media (max-width: 769px) {
  .cart-details-card {
    display: flex;
    height: 521px;
    overflow-y: scroll;
    min-width: 100%;
    gap: 15px;
    flex-direction: column;
  }
  .checkout-card {
    width: 100%;
    height: auto;
    flex-shrink: 0;
  }
  .cart-details-section {
    padding-inline: 40px;
  }
  .ellipsis-mobile-btn {
    display: flex;
    width: 51px;
    height: 50px;
    padding: 3px 7px;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 5px;
    background: #f5f5f5;
    transform: rotate(90deg);
  }
  .cart-summary-version-row {
    display: flex;
  }
  .cart-details-version-col {
    display: flex;
    flex-direction: column;
    gap: 10px !important;
  }
  .cart-summary-check-box .ant-checkbox {
    transform: scale(1.5);
  }
  .proceed-to-check-out-col {
    min-width: 100% !important;
    bottom: 3rem;
  }
  .cart-details-card .ant-col-md-16 {
    max-width: 100% !important;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .cart-details-card {
    display: flex;
    height: 521px;
    overflow-y: scroll;
    width: 100%;
    gap: 15px;
    flex-direction: column;
  }
  .checkout-total-button-row {
    gap: 10%;
  }
  .cart-sub-total-price-version-col {
    display: flex;
    flex-direction: column;
  }
  .cart-sub-total-price-version {
    color: #0a0f0d;
    font-family: Roboto;
    font-size: 23px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .proceed-to-checkout {
    height: 60px !important;
  }
  .cart-summary-check-box .ant-checkbox {
    transform: scale(1.3) !important;
    margin-top: 16px !important;
  }
  .checkout-card.ant-card .ant-card-body {
    padding: 25px !important;
  }
}

@media (max-width: 431px) {
  .checkout-card {
    width: 100%;
    height: auto !important;
    flex-shrink: 0;
  }
  .proceed-to-checkout {
    padding: 12px 18px;
  }
  .cart-details-section {
    padding-inline: 20px;
  }
  .ellipsis-mobile-btn {
    display: flex;
    width: 41px;
    height: 40px;
    padding: 3px 7px;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 5px;
    background: #f5f5f5;
  }

  .number-of-campaigns-collected {
    font-size: 16px !important;
    line-height: 21.5px !important;
  }
}
@media (max-width: 400px) {
  .checkout-card {
    width: 100%;
    height: auto !important;
    flex-shrink: 0;
  }
  .cart-details-section {
    padding-inline: 20px;
  }
}
@media (min-width: 376px) and (max-width: 430px) {
  .card-campaign-titles {
    font-size: 15px !important;
  }
  .card-campaign-text {
    font-size: 15px !important;
  }
  .card-campaign-price-text {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .cart-sub-total-price-version-col {
    display: flex;
    flex-direction: column;
  }
  .cart-sub-total-price-version {
    font-size: 18px !important;
    font-weight: 700 !important;
  }
  .card-campaign-total {
    font-size: 16px !important;
    line-height: 25.5px !important;
  }
  .proceed-to-checkout {
    height: 40px !important;
    width: 100% !important;
  }
  .proceed-to-checkout {
    color: #fff;
    font-family: Roboto;
    font-size: 16px;
  }
  .checkout-total-button-row {
    justify-content: space-around !important;
  }
  .cart-summary-check-box .ant-checkbox {
    margin-top: 1rem !important;
  }
  .checkout-card.ant-card .ant-card-body {
    padding: 15px !important;
  }
}
@media (min-width: 321px) and (max-width: 375px) {
  .cart-summary-txt {
    font-size: 20px !important;
  }
  .card-campaign-titles {
    font-size: 14px !important;
  }
  .card-campaign-text {
    font-size: 14px !important;
  }
  .card-campaign-price-text {
    font-size: 14px !important;
    font-weight: 500 !important;
  }
  .cart-summary-check-box .ant-checkbox {
    transform: scale(1.3) !important;
    margin-top: 14px !important;
  }
  .card-campaign-total {
    font-size: 16px !important;
  }
  .cart-sub-total-price-version {
    font-size: 16px !important;
    font-weight: 700 !important;
  }
  .proceed-to-checkout {
    width: 100% !important;
  }
  .proceed-to-checkout {
    font-size: 14px !important;
  }
  .checkout-total-button-row {
    justify-content: space-between !important;
  }
  .number-of-campaigns-collected {
    font-size: 14px !important;
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .cart-summary-check-box .ant-checkbox {
    transform: scale(1.3) !important;
  }
  .cart-summary-version-row {
    display: flex;
    flex-direction: column;
  }
  .cart-summary-txt {
    font-size: 18px !important;
  }
  .total-price-col-cart-campaign {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .card-campaign-titles {
    font-size: 14px !important;
  }
  .card-campaign-text {
    font-size: 13px !important;
  }
  .card-campaign-price-text {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .card-campaign-total {
    font-size: 14px !important;
  }
  .cart-sub-total-price-version {
    font-size: 16px !important;
    font-weight: 700 !important;
  }
  .checkout-total-button-row {
    justify-content: space-around !important;
  }
  .proceed-to-checkout {
    height: 35px !important;
    width: 100% !important;
  }
  .proceed-to-checkout {
    font-size: 13px !important;
  }
  .number-of-campaigns-collected {
    font-size: 14px !important;
    line-height: 21.5px !important;
  }
  .checkout-card.ant-card .ant-card-body {
    padding: 25px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/cart-campaigns/CartCampaigns.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;EACE;iCAC+B;EAC/B,8BAA8B;AAChC;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,+BAA+B;EAC/B,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE;iCAC+B;EAC/B,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,yCAAyC;AAC3C;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,OAAO;AACT;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;EAClB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;IAC1B,YAAY;EACd;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,sBAAsB;EACxB;EACA;IACE,QAAQ;EACV;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;AACF;AACA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;IAC3B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".card-campaign-titles {\n  font-family: Roboto;\n  color: #8e9190;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  gap: 10;\n  line-height: 24px;\n}\n.cart-details-card {\n  height: 700px;\n  overflow-y: auto;\n}\n\n.card-campaign-text {\n  color: #0a0f0d;\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.card-campaign-price-text {\n  color: #0a0f0d;\n  font-family: Roboto;\n  font-size: 23px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.divider-editor-col {\n  display: flex !important;\n  justify-content: end !important;\n  padding-top: 45px !important;\n}\n.check-box-campaigns {\n  /* padding-inline: 30px !important;\n  padding-top: 29px !important; */\n  margin-bottom: 20px !important;\n}\n.edit-campaign-space-div {\n  padding-left: 35px !important;\n  padding-top: 60px !important;\n}\n.edit-campaign-text {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n}\n.campaign-actions {\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  cursor: pointer;\n}\n.card-campaign-total {\n  color: #5b5e5d;\n  font-family: Roboto;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 28.5px;\n}\n.proceed-to-checkout {\n  color: #fff;\n  font-family: Roboto;\n  font-size: 19px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  display: inline-flex;\n  padding: 12px 60px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  background: #d2042d;\n  margin-top: 10px;\n  height: 40px !important;\n  width: 100% !important;\n}\n.proceed-to-checkout.ant-btn-variant-solid:disabled {\n  background-color: #d2042d !important;\n  color: #fff !important;\n}\n.proceed-to-checkout:hover {\n  color: #fff;\n  background-color: #910621 !important;\n}\n.checkout-card {\n  width: 100%;\n  height: auto;\n  flex-shrink: 0;\n}\n.checkout-card.ant-card .ant-card-body {\n  padding: 42px !important;\n}\n.cart-details-section {\n  padding-inline: 75px;\n}\n.number-of-campaigns-collected {\n  font-family: Roboto;\n  font-weight: 600;\n  font-size: 19px;\n  line-height: 28.5px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n}\n.card-campaign-total-number {\n  font-family: Roboto;\n  font-weight: 700;\n  font-size: 23px;\n  line-height: 28.5px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #000);\n}\n.card-campaign-actions-col {\n  display: flex;\n  justify-content: end;\n  padding-top: 45px;\n  margin-bottom: 10px;\n  align-items: center;\n  gap: 15px !important;\n}\n\n.card-campaign-actions-div {\n  padding-left: 35px;\n  padding-top: 60px;\n}\n\n.card-campaign-actions-div-text {\n  font-size: 16px;\n  font-weight: 600;\n}\n.badge {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  opacity: 1;\n  border-bottom-left-radius: 10px;\n  padding: 8px;\n  gap: 8px;\n  /* background: #ffd9e1; */\n  padding: 4px 8px;\n}\n.expired-ribbon-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.check-box-campaigns {\n  /* padding-inline: 30px !important;\n  padding-top: 29px !important; */\n  margin-bottom: 20px !important;\n  border: 1px solid #e5e7eb !important;\n  border-radius: 16px;\n}\n.check-box-campaigns.ant-card .ant-card-body {\n  padding: 0px !important;\n}\n.check-out-version-bottom-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.checkout-total-button-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n\n.number-of-products-cart-campaign-col {\n  display: flex;\n  flex-direction: column;\n}\n.number-of-products-cart-campaign-row {\n  gap: 10px !important;\n}\n.cart-campaign-warning-icon-version {\n  width: 20px !important;\n}\n.subtotal-label {\n  color: #5b5e5d;\n  font-weight: bold;\n}\n.cart-campaign-warning-icon {\n  cursor: pointer;\n}\n.campaign-actions-icons {\n  margin-right: 7px !important;\n}\n.remove-terms-in-cart {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 19px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  color: var(--Colors-Primary-500, #0a0f0d);\n}\n.highleted-remove-terms {\n  cursor: pointer;\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 19px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.highleted-remove-terms:hover {\n  text-decoration: none !important;\n}\n.any-terms-applied-remove-link {\n  justify-content: center;\n  margin-top: 1rem !important;\n}\n.alert-note-text {\n  font-family: Roboto;\n  font-weight: bold;\n  font-size: 19px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  color: var(--Colors-Primary-500, #0a0f0d);\n}\n.campaign-actions-container {\n  display: flex;\n  align-items: center !important;\n}\n.re-designed-cart-brand-awareness {\n  width: 45%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 5%;\n}\n.remove-campaign-text {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Regular;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: 0.37px;\n  color: #d2042d;\n  cursor: pointer;\n}\n.cart-remove-from-cart {\n  margin-right: 10px;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  gap: 5px;\n}\n@media (min-width: 1024px) and (max-width: 1440px) {\n  .cart-details-section {\n    padding-inline: 50px !important;\n  }\n  .card-campaign-titles {\n    font-size: 14px !important;\n  }\n  .card-campaign-price-text {\n    font-size: 17px !important;\n  }\n  .proceed-to-checkout {\n    width: 100% !important;\n  }\n  .campaign-actions {\n    font-size: 15px !important;\n  }\n  .card-campaign-text {\n    font-size: 15px !important;\n  }\n  .campaign-actions-icons {\n    width: 17px !important;\n    height: 17px !important;\n    margin-right: 2px !important;\n  }\n  .card-campaign-total {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n  .card-campaign-total {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n  .number-of-campaigns-collected {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n  .card-campaign-total-number {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n  .proceed-to-checkout {\n    font-size: 16px !important;\n  }\n  .alert-note-text {\n    font-size: 16px !important;\n  }\n  .remove-terms-in-cart {\n    font-size: 16px !important;\n  }\n  .highleted-remove-terms {\n    font-size: 16px !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 1023px) {\n  .card-campaign-price-text {\n    font-size: 20px !important;\n  }\n  .check-box-cart-col {\n    margin-bottom: 3rem !important;\n  }\n  .checkout-card {\n    width: 100%;\n    height: auto;\n    flex-shrink: 0;\n    position: sticky;\n  }\n  .proceed-to-checkout {\n    width: 100% !important;\n  }\n  .meidum-screen-action-buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n    margin-top: 20px;\n  }\n  .check-box-campaigns {\n    padding-bottom: 20px !important;\n  }\n  .cart-details-card {\n    height: 634px !important;\n  }\n  .checkout-card {\n    height: auto !important;\n  }\n  .card-campaign-total {\n    font-size: 17px !important;\n    line-height: 24.5px !important;\n  }\n  .cart-details-section {\n    padding-inline: 25px !important;\n  }\n  .proceed-to-checkout {\n    font-size: 16px !important;\n  }\n  .alert-note-text {\n    font-size: 16px !important;\n  }\n  .remove-terms-in-cart {\n    font-size: 16px !important;\n  }\n  .highleted-remove-terms {\n    font-size: 16px !important;\n  }\n  .number-of-campaigns-collected {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n  .card-campaign-total-number {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n}\n@media (min-width: 770px) and (max-width: 820px) {\n  .proceed-to-checkout {\n    font-size: 14px !important;\n  }\n}\n@media (max-width: 769px) {\n  .cart-details-card {\n    display: flex;\n    height: 521px;\n    overflow-y: scroll;\n    min-width: 100%;\n    gap: 15px;\n    flex-direction: column;\n  }\n  .checkout-card {\n    width: 100%;\n    height: auto;\n    flex-shrink: 0;\n  }\n  .cart-details-section {\n    padding-inline: 40px;\n  }\n  .ellipsis-mobile-btn {\n    display: flex;\n    width: 51px;\n    height: 50px;\n    padding: 3px 7px;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    border-radius: 5px;\n    background: #f5f5f5;\n    transform: rotate(90deg);\n  }\n  .cart-summary-version-row {\n    display: flex;\n  }\n  .cart-details-version-col {\n    display: flex;\n    flex-direction: column;\n    gap: 10px !important;\n  }\n  .cart-summary-check-box .ant-checkbox {\n    transform: scale(1.5);\n  }\n  .proceed-to-check-out-col {\n    min-width: 100% !important;\n    bottom: 3rem;\n  }\n  .cart-details-card .ant-col-md-16 {\n    max-width: 100% !important;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .cart-details-card {\n    display: flex;\n    height: 521px;\n    overflow-y: scroll;\n    width: 100%;\n    gap: 15px;\n    flex-direction: column;\n  }\n  .checkout-total-button-row {\n    gap: 10%;\n  }\n  .cart-sub-total-price-version-col {\n    display: flex;\n    flex-direction: column;\n  }\n  .cart-sub-total-price-version {\n    color: #0a0f0d;\n    font-family: Roboto;\n    font-size: 23px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n  .proceed-to-checkout {\n    height: 60px !important;\n  }\n  .cart-summary-check-box .ant-checkbox {\n    transform: scale(1.3) !important;\n    margin-top: 16px !important;\n  }\n  .checkout-card.ant-card .ant-card-body {\n    padding: 25px !important;\n  }\n}\n\n@media (max-width: 431px) {\n  .checkout-card {\n    width: 100%;\n    height: auto !important;\n    flex-shrink: 0;\n  }\n  .proceed-to-checkout {\n    padding: 12px 18px;\n  }\n  .cart-details-section {\n    padding-inline: 20px;\n  }\n  .ellipsis-mobile-btn {\n    display: flex;\n    width: 41px;\n    height: 40px;\n    padding: 3px 7px;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    border-radius: 5px;\n    background: #f5f5f5;\n  }\n\n  .number-of-campaigns-collected {\n    font-size: 16px !important;\n    line-height: 21.5px !important;\n  }\n}\n@media (max-width: 400px) {\n  .checkout-card {\n    width: 100%;\n    height: auto !important;\n    flex-shrink: 0;\n  }\n  .cart-details-section {\n    padding-inline: 20px;\n  }\n}\n@media (min-width: 376px) and (max-width: 430px) {\n  .card-campaign-titles {\n    font-size: 15px !important;\n  }\n  .card-campaign-text {\n    font-size: 15px !important;\n  }\n  .card-campaign-price-text {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  .cart-sub-total-price-version-col {\n    display: flex;\n    flex-direction: column;\n  }\n  .cart-sub-total-price-version {\n    font-size: 18px !important;\n    font-weight: 700 !important;\n  }\n  .card-campaign-total {\n    font-size: 16px !important;\n    line-height: 25.5px !important;\n  }\n  .proceed-to-checkout {\n    height: 40px !important;\n    width: 100% !important;\n  }\n  .proceed-to-checkout {\n    color: #fff;\n    font-family: Roboto;\n    font-size: 16px;\n  }\n  .checkout-total-button-row {\n    justify-content: space-around !important;\n  }\n  .cart-summary-check-box .ant-checkbox {\n    margin-top: 1rem !important;\n  }\n  .checkout-card.ant-card .ant-card-body {\n    padding: 15px !important;\n  }\n}\n@media (min-width: 321px) and (max-width: 375px) {\n  .cart-summary-txt {\n    font-size: 20px !important;\n  }\n  .card-campaign-titles {\n    font-size: 14px !important;\n  }\n  .card-campaign-text {\n    font-size: 14px !important;\n  }\n  .card-campaign-price-text {\n    font-size: 14px !important;\n    font-weight: 500 !important;\n  }\n  .cart-summary-check-box .ant-checkbox {\n    transform: scale(1.3) !important;\n    margin-top: 14px !important;\n  }\n  .card-campaign-total {\n    font-size: 16px !important;\n  }\n  .cart-sub-total-price-version {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n  }\n  .proceed-to-checkout {\n    width: 100% !important;\n  }\n  .proceed-to-checkout {\n    font-size: 14px !important;\n  }\n  .checkout-total-button-row {\n    justify-content: space-between !important;\n  }\n  .number-of-campaigns-collected {\n    font-size: 14px !important;\n  }\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .cart-summary-check-box .ant-checkbox {\n    transform: scale(1.3) !important;\n  }\n  .cart-summary-version-row {\n    display: flex;\n    flex-direction: column;\n  }\n  .cart-summary-txt {\n    font-size: 18px !important;\n  }\n  .total-price-col-cart-campaign {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n  .card-campaign-titles {\n    font-size: 14px !important;\n  }\n  .card-campaign-text {\n    font-size: 13px !important;\n  }\n  .card-campaign-price-text {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n  }\n  .card-campaign-total {\n    font-size: 14px !important;\n  }\n  .cart-sub-total-price-version {\n    font-size: 16px !important;\n    font-weight: 700 !important;\n  }\n  .checkout-total-button-row {\n    justify-content: space-around !important;\n  }\n  .proceed-to-checkout {\n    height: 35px !important;\n    width: 100% !important;\n  }\n  .proceed-to-checkout {\n    font-size: 13px !important;\n  }\n  .number-of-campaigns-collected {\n    font-size: 14px !important;\n    line-height: 21.5px !important;\n  }\n  .checkout-card.ant-card .ant-card-body {\n    padding: 25px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
